import React from "react";
import './styles/FAQ.css';
function NotFound() {
    return (
        <>
       {/* <section id="about4" className="about">
                <div className="wrap"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">

                            <h1 className="heading"> <span className="hero-highlight">Personal Care Assistance (PCA)</span>  <br /> Compassionate In-Home <span className="hero-highlight">Support</span></h1>
                            <p className="supporting">
                                Providing personalized and dedicated care to help individuals with daily activities.
                            </p>
                        </div>
                    </div>
                </div>
            </section> */}
        <section class="page_404">
	<div class="container">
		<div class="row">	
		<div class="col-sm-12 ">
		<div class="col-sm-10 col-sm-offset-1  text-center">
		<div class="four_zero_four_bg">
			<h1 class="text-center ">404</h1>
		
		
		</div>
		
		<div class="contant_box_404">
		<h3 class="h2">
		Look like you're lost
		</h3>
		
		<p>the page you are looking for not avaible!</p>
		
		<a href="/" class="nav0cta1">Go to Home</a>
	</div>
		</div>
		</div>
		</div>
	</div>
</section>
        </>
    );
}

export default NotFound;